import moment from 'moment'

import { CsvHeader } from '../../services/csv-export/csv-export.service'

export interface LicenseUsageCsvRow {
  name?: string
  email?: string
  department?: string
  reportTo?: string
  businessMeetingCount: number
  usedSeconds: number
  limitSeconds: number
  extraChargeCount: number
}

export type LicenseUsageCsvData = {
  name: string
  email: string
  department: string
  reportTo: string
  businessMeetingCount: number
  usedMinutes: number
  limitMinutes: number
  extraChargeCount: number
  [key: string]: string | number | Date | null
}

export const LICENSE_USAGE_CSV_HEADERS: readonly CsvHeader<LicenseUsageCsvData>[] =
  [
    { label: '名前', key: 'name' },
    { label: 'メールアドレス', key: 'email' },
    { label: '部署', key: 'department' },
    { label: '上司', key: 'reportTo' },
    { label: '商談回数', key: 'businessMeetingCount' },
    { label: '利用時間（分）', key: 'usedMinutes' },
    { label: '上限時間（分）', key: 'limitMinutes' },
    { label: '追加購入回数', key: 'extraChargeCount' },
  ]

/** 表示順を保ち、未アサイン項目の表示補完と秒から分への切り捨てを行って CSV 用データに変換する。 */
export function toLicenseUsageCsvData(
  rows: LicenseUsageCsvRow[],
): LicenseUsageCsvData[] {
  return rows.map((row) => ({
    name: row.name ?? '未アサイン',
    email: row.email ?? '',
    department: row.department ?? '',
    reportTo: row.reportTo ?? '',
    businessMeetingCount: row.businessMeetingCount,
    usedMinutes: Math.floor(row.usedSeconds / 60),
    limitMinutes: Math.floor(row.limitSeconds / 60),
    extraChargeCount: row.extraChargeCount,
  }))
}

/** 選択月を含むライセンス利用状況 CSV のファイル名を返す。 */
export function buildLicenseUsageCsvFileName(date: Date): string {
  return `license_usage_${moment(date).format('YYYYMM')}.csv`
}
